import axios from 'axios';
import { IActivateInvitationPayload, ICreateInvitationPayload, IInvitation } from 'entities/Invitation/Invitation.models';

const basePath = 'invitation';

export const invitationTransport = {
  getInvitation: (hash: string): Promise<IInvitation> => axios.get(`${basePath}/${hash}`),
  activateInvitation: (payload: IActivateInvitationPayload): Promise<IInvitation> => axios.patch(`${basePath}/activate`, payload),
  inviteUser: (payload: ICreateInvitationPayload): Promise<IInvitation> => axios.post(`${basePath}`, payload),
};
